import * as React from 'react'
import getConfig from 'next/config'
import StoryblokService from 'utils/storyblok-service'
// import parseTinyLink from 'utils/parseTinyLink'
import { cdnUrl, parseSeoData } from 'utils/storyblok'
import { Page } from '../[[...uri]]'

const Article = (props) => <Page {...props} />

export async function getServerSideProps(ctx) {
  const { params, preview, query } = ctx
  if (query) StoryblokService.setQuery(query)
  if (preview) StoryblokService.devMode = true

  const uri = [params?.uri]
  // const tinyLink = await parseTinyLink(uri, ctx)
  // const slug = tinyLink.uri.length > 0 ? tinyLink.uri.join('/') : 'home'
  const slug = uri.length > 0 ? uri.join('/') : 'home'
  const { publicRuntimeConfig } = getConfig()

  const page = await StoryblokService.get(`cdn/stories/articles/${slug}?language=${ctx.locale}`, {
    resolve_relations: 'author',
    version: publicRuntimeConfig.STORYBLOK_ENV,
  })

  if (!page?.data?.story?.content) {
    return {
      notFound: true,
    }
  }

  const images =
    (page.data.story.content.images &&
      page.data.story.content.images?.map((image) => cdnUrl(image.filename))) ||
    []

  const header = {
    component: 'ArticleHero',
    images,
    publishDate: page?.data?.story?.content?.date.split(' ')?.[0] || '',
    heading: page?.data?.story?.content?.title || '',
    subheading: page?.data?.story?.tag_list?.join(' • ') || '',
    text: page?.data?.story?.content?.intro || '',
  }
  const body = [header, ...page?.data?.story?.content.body]

  if (page?.data?.story?.content?.author) {
    const author = {
      component: 'ArticleAuthor',
      mediaSrc: cdnUrl(page?.data?.rels[0]?.content?.mediaSrc?.filename) || '',
      author: page?.data?.rels[0]?.name || '',
      occupation: page?.data?.rels[0]?.content?.occupation || '',
      text: page?.data?.rels[0]?.content?.text || '',
    }
    body.push(author)
  }

  const seo = parseSeoData(page)

  return {
    props: {
      page: {
        ...page,
        seo,
        data: {
          ...page.data,
          story: {
            ...page.data.story,
            content: {
              ...page.data.story.content,
              body,
            },
          },
        },
      },
      // tinyLink,
    },
  }
}

export default Article
